import { makeObservable, observable, action } from "mobx";

const STORAGE_KEY = 'ssb:visible';
const LEGACY_STORAGE_KEY = 'ssb:mobileVisible';

/**
 * Controls whether the server-stats badge is shown — as the header badge on desktop
 * and as a floating overlay on mobile (≤768px). Persisted in localStorage; toggled
 * from the chat "..." menu (admins only).
 */
class StatsVisibilityService {
  @observable visible: boolean = (() => {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw !== null) return raw === '1';
    // Migrate the pre-desktop-toggle key (it only controlled the mobile overlay).
    const legacy = localStorage.getItem(LEGACY_STORAGE_KEY);
    if (legacy !== null) {
      localStorage.setItem(STORAGE_KEY, legacy);
      return legacy === '1';
    }
    return true;
  })();

  constructor() {
    makeObservable(this);
  }

  @action
  public toggle(): void {
    this.visible = !this.visible;
    localStorage.setItem(STORAGE_KEY, this.visible ? '1' : '0');
  }
}

const statsVisibilityService = new StatsVisibilityService();
export default statsVisibilityService;
